import CommonError from '../Common/CommonError'

const Error404Container = () => {
  return (
    <CommonError color="primary" src="4" />
  )
}

export default Error404Container